import { Point } from "ol/geom";
import "ol/ol.css";
import { fromLonLat } from "ol/proj";
import { useEffect, useState } from "react";
import {
  RControl,
  RFeature,
  RLayerTileWebGL,
  RLayerVector,
  RMap,
  ROSM,
  ROSMWebGL,
  ROverlay,
  RStyle,
} from "rlayers";
import "rlayers/control/layers.css";
import locationIcon from "../assets/icons/rider.svg";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { useSearchParams } from "react-router-dom";

const Map = (props: any) => {
  const { riderCoordinates } = props;
  const [hoveredRider, setHoveredRider] = useState<string | null>(null);
  const [searchParams, setSearchParms] = useSearchParams({
    searchQuery: "",
  });
  const searchQuery = searchParams.get("searchQuery");
  const handleSearch = (value) => {
    searchParams.set("searchQuery", value);
    setSearchParms(searchParams);
  };

  // const reverseGeocode = async (lat: number, lon: number) => {
  //   try {
  //     const response = await fetch(
  //       `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lon}&format=json`
  //     );
  //     const data = await response.json();
  //     return data?.display_name || "Address not found";
  //   } catch (error) {
  //     console.error("Error fetching address:", error);
  //     return "Error fetching address";
  //   }
  // };

  // const handleAddress = async (rider: any) => {
  //   const address = await reverseGeocode(
  //     rider?.coordinate?.[0], // latitude
  //     rider?.coordinate?.[1] // longitude
  //   );
  // };

  const openInGoogleMaps = (lat: number, lon: number) => {
    const googleMapsUrl = `https://www.google.com/maps?q=${lat},${lon}`;
    window.open(googleMapsUrl, "_blank");
  };

  return (
    <>
      <div className="relative">
        {/* Search Box */}
        <input
          type="text"
          placeholder="Search riders..."
          value={searchQuery}
          onChange={(e) => handleSearch(e.target.value)}
          className={tw`absolute top-4 left-10 p-2 border border-gray-300 rounded bg-white z-10`}
        />

        <RMap
          width={"100%"}
          height={"100vh"}
          initial={{ center: fromLonLat([84.033, 28.103]), zoom: 8 }}
        >
          <RControl.RLayers>
            <RLayerTileWebGL
              properties={{ label: "Google Maps" }}
              url={`http://mt0.google.com/vt/lyrs=m&hl=en&x={x}&y={y}&z={z}`}
              attributions="Map data © Google"
            />
            <ROSMWebGL properties={{ label: "OSM" }} />
          </RControl.RLayers>

          <RLayerVector>
            {riderCoordinates?.map((rider: any) => (
              <RFeature
                key={rider.id}
                geometry={
                  new Point(
                    fromLonLat([rider?.coordinate?.[1], rider?.coordinate?.[0]])
                  )
                }
                onPointerEnter={() => {
                  // handleAddress(rider);
                  setHoveredRider(rider?.user?.id);
                }}
                onPointerLeave={() => setHoveredRider(null)}
                onClick={() =>
                  openInGoogleMaps(
                    rider?.coordinate?.[0], // latitude
                    rider?.coordinate?.[1] // longitude
                  )
                }
              >
                <RStyle.RStyle>
                  <RStyle.RIcon src={locationIcon} anchor={[0.5, 0.8]} />
                </RStyle.RStyle>
                {hoveredRider === rider?.user?.id && (
                  <ROverlay
                    className={tw`bg-white py-2 px-1 rounded text-center`}
                  >
                    <p>{rider?.user?.full_name || "Unknown Rider"}</p>
                    <p>{rider?.user?.mobile_number}</p>
                  </ROverlay>
                )}
              </RFeature>
            ))}
          </RLayerVector>
        </RMap>
      </div>
    </>
  );
};

export default Map;
